/**
 * The maintenance lock (Frank, 16 Oct 2026): "Whenever there's a problem
 * with our Convex, there's always a screen that pops up … Can we have a way
 * where we can enforce that screen on some brands … or for all brands … I
 * turn on, they see that screen, then I can always turn off."
 *
 * Then, the same day: "Say we're having some issues, we'll get back … It's
 * supposed to lock everything. The brand isn't even supposed to log into
 * their POS system. It's supposed to be an overlay covering everything."
 *
 * So: the switch is a `maintenanceModes` row (convex/platformAdmin/
 * maintenance.ts), scope "all" or one brand. Every page on the brand's
 * address — the shop, the coded website, sign-in and the till — is covered
 * by the outage screen itself (components/maintenance/StatusScreen,
 * "service_down"), for EVERYONE, Kuttos admins included, until it is
 * switched off. Nothing on it says it was switched on.
 */

/** The longest line we may add under the message. */
export const MAINTENANCE_NOTE_MAX = 200;

/** The outage screen's words — the maintenance lock shows exactly these. */
export const MAINTENANCE_COPY = {
  title: "Temporary System Maintenance",
  message: "We're experiencing a brief service interruption. Our team is working on it and we'll be back very soon.",
  subMessage: "Your store and all your data are completely safe. This page will automatically retry.",
} as const;

/** A note as stored and shown: one line, trimmed, at most MAINTENANCE_NOTE_MAX characters. */
export function cleanMaintenanceNote(note: string | null | undefined): string {
  return String(note ?? "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, MAINTENANCE_NOTE_MAX);
}
